import React, { createContext, useState } from "react";
import { apiService } from "../services/apiService";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [UUID, setUUID] = useState(localStorage.getItem("UUID") || null);
    const [token, setToken] = useState(localStorage.getItem("token") || null);
    const [HuserID, setHuserID] = useState(
        localStorage.getItem("HuserID") || null
    );
    const [DDroleID, setDDroleID] = useState(
        localStorage.getItem("DDroleID") || null
    );
    const [cancellactiverequestyn, setCancellactiverequestyn] = useState(
        localStorage.getItem("cancellactiverequestyn") || null
    );
    // Simple React state - no localStorage persistence
    const [menuData, setMenuData] = useState([]);
    const [defaultRoute, setDefaultRoute] = useState("/profile");

    const login = async (credentials) => {
        try {
            // Clear any existing menu data
            setMenuData([]);
            setDefaultRoute("/profile");

            const data = await apiService.login(credentials);

            setToken(data[0].Token);
            localStorage.setItem("token", data[0].Token);

            setUUID(data[0].UUID);
            localStorage.setItem("UUID", data[0].UUID);

            setHuserID(data[0].HuserID);
            localStorage.setItem("HuserID", data[0].HuserID);

            setDDroleID(data[0].DDroleID);
            localStorage.setItem("DDroleID", data[0].DDroleID);

            setCancellactiverequestyn(data[0].cancellactiverequestyn);
            localStorage.setItem("cancellactiverequestyn", data[0].cancellactiverequestyn);

            let finalDefaultRoute = "/profile"; // Default fallback

            // Extract menu data from menuList property and filter by menuLevel === 1
            if (data && data[0] && data[0].menuList && Array.isArray(data[0].menuList)) {
                const allMenuItems = data[0].menuList;
                
                // Filter menu items where menuLevel === 1
                const menuItems = allMenuItems.filter(item => 
                    item.menuLevel === 1 && 
                    item.displayname && 
                    item.route && 
                    item.menuCode
                );
                
                if (menuItems.length > 0) {
                    setMenuData(menuItems);
                    
                    // Find the default page (item with defaultpage === 1)
                    const defaultPageItem = menuItems.find(item => item.defaultpage === 1);
                    
                    finalDefaultRoute = defaultPageItem ? defaultPageItem.route : "/profile";
                    
                    setDefaultRoute(finalDefaultRoute);
                } else {
                    setMenuData([]);
                    setDefaultRoute("/profile");
                }
            } else {
                setMenuData([]);
                setDefaultRoute("/profile");
            }
            
            return finalDefaultRoute; // Return the default route
            
        } catch (error) {
            console.error("Login failed:", error);
            throw error;
        }
    };

    const logout = () => {
        setUUID(null);
        setHuserID(null);
        setDDroleID(null);
        setCancellactiverequestyn(null);
        setMenuData([]);
        setDefaultRoute("/profile");
        localStorage.removeItem("UUID");
        localStorage.removeItem("HuserID");
        localStorage.removeItem("DDroleID");
        localStorage.removeItem("cancellactiverequestyn");
        localStorage.removeItem("token");
    };

    return (
        <AuthContext.Provider value={{ UUID, HuserID, DDroleID, cancellactiverequestyn, menuData, defaultRoute, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
